import React from 'react';
import { HelpMenuDashboard, DefaultDashboard } from '../dashboard';
import { menuPoll } from './domain/menuPoll';
import { PollPanel } from './infrastructure/PollPanel';
import { PollResult } from './infrastructure/PollResult';
import { PanelQuestion } from './compoment/pollsQuestion/panelPollQuestion';
import { PanelResponse } from './compoment/pollsQuestion/panelPollResponse';
import { GraphicResults } from './compoment/graphicResults/graphicResults';
import { ResultadosPorUsuario } from './compoment/graphicResults/resultsUser';

export const Poll = () => {

    const components = {
        Default: DefaultDashboard,
        Poll: PollPanel,
        PollResult: PollResult,
        PanelQuestion: PanelQuestion,
        PanelResponse: PanelResponse,
        graphicResults: GraphicResults,
        resultadoDeUsuario: ResultadosPorUsuario,
    };

    return (
        <>
            {HelpMenuDashboard().RenderMenu(menuPoll(), components)}
        </>
    );
}
